import type { Schema } from '@biteinc/common';
import { MaitredActivityUpdateType } from '@biteinc/enums';

export function buildMaitredActivityListFilterSchema(
  hasOrg: boolean,
  hasSite: boolean,
  hasLocation: boolean,
  lockDownUsername: boolean,
): Schema.ModelTypedObjectField {
  const schema: Schema.ModelTypedObjectField = {
    type: 'object',
    fields: {
      fromTimestamp: {
        type: 'timestamp',
        displayName: 'From',
        futureDateLimit: 'disallowed',
        useSiteTimezone: hasSite,
      },
      toTimestamp: {
        type: 'timestamp',
        displayName: 'To',
        futureDateLimit: 'disallowed',
        useSiteTimezone: hasSite,
      },
      activityBy: {
        type: 'email',
        displayName: 'Activity By',
        ...(lockDownUsername && {
          isReadOnly: true,
        }),
        tooltip: {
          text: 'Username of the user that performed the activity',
        },
      },
      ...(hasLocation && {
        modelQuery: {
          type: 'keyString',
          displayName: 'Model',
          tooltip: {
            text: 'Model Name, Bite ID, or POS ID',
          },
        },
        updateType: {
          displayName: 'Update Type',
          type: 'stringEnum',
          enum: MaitredActivityUpdateType,
          ui: 'dropdown',
          isNullable: true,
        },
      }),
      descriptionQuery: {
        type: 'shortString',
        displayName: 'Description',
        tooltip: {
          text: '"tip" for tipping events, etc',
        },
      },
      ...(hasOrg &&
        !hasSite &&
        !hasLocation && {
          locationGroupId: {
            displayName: 'Include Location-level Activities',
            type: 'keyString',
            ui: 'dropdown',
            isNullable: true,
            placeholder: 'Select Location Group',
          },
        }),
    },
  };
  return schema;
}
